module.exports = __webpack_public_path__ + "img/weiboicon.59d1500d.png";